/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_External_Writes_LabelInputs */



/**
* | output |
* | --- |
* | "Allow unattended external writes" |
*
* @param {Agent_Policy_External_Writes_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_external_writes_label = /** @type {((inputs?: Agent_Policy_External_Writes_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_External_Writes_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbeaufsichtigte externe Schreibvorgänge erlauben")
	return /** @type {LocalizedString} */ ("Allow unattended external writes")
});